import { FC } from 'react';

import { Divider } from '@bonusly/design-system';

import { EvaluationType, Feedback } from '../../lib';
import { MessageInput } from '../message/message-input';
import { useFeedbackCard } from './hooks/use-feedback-card';
import { MessageList } from './message-list';

interface Props {
	feedback: Feedback;
	variant?: 'responseModal';
}
export const FeedbackMessages: FC<Props> = ({ feedback, variant }) => {
	const { isEditable, placeholder } = useFeedbackCard();

	if (feedback.isExpired()) {
		return null;
	}

	return (
		<>
			<MessageList messages={feedback.messages} />

			{isEditable && (
				<>
					<Divider />
					<MessageInput
						key={feedback.id}
						feedbackId={feedback.id}
						placeholder={placeholder}
						lastSavedDraft={feedback.lastDraft}
						type={EvaluationType.Requested}
						variant={variant}
						feedbackTemplate={feedback.template}
						feedbackState={feedback.state}
						recipient={feedback.receiver}
					/>
				</>
			)}
		</>
	);
};
